<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline m-0">
        <v-flex xs9> <v-icon>add</v-icon> Asignación Horario</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="p-0">
          <v-container grid-list-md style="min-width: 100%;" class="py-0 px-4">
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-radio-group v-model="tipo_asignacion">
                  <v-radio label="Continuo" value="1"></v-radio>
                  <v-radio label="Discontinuo" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.fecha_desde"
                  required
                  outline
                  clearable
                  label="Fecha de inicio"
                  type="date"
                  @input="actualizaFecha()"
                  :rules="[
                    v => {
                      if ([undefined, null, ''].includes(form.fecha_desde)) {
                        return 'El campo es obligatorio.';
                      }
                      if (
                        $moment(form.fecha_desde) >= $moment() ||
                        $moment(form.fecha_desde, 'YYYY-MM-DD').format(
                          'YYYY-MM-DD'
                        ) == $moment().format('YYYY-MM-DD')
                      ) {
                        return 'La fecha inicio no puede ser despues o igual a la fecha actual';
                      }
                      if (
                        form.fecha_hasta &&
                        $moment(form.fecha_desde) > $moment(form.fecha_hasta)
                      ) {
                        return 'La fecha inicio no puede ser despues de la fecha fin';
                      }
                      return true;
                    }
                  ]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.fecha_hasta"
                  required
                  label="Fecha de finalización"
                  type="date"
                  outline
                  clearable
                  @input="actualizaFecha()"
                  :rules="[
                    v => {
                      if ([undefined, null, ''].includes(form.fecha_hasta)) {
                        return 'El campo es obligatorio.';
                      }
                      if (
                        $moment(form.fecha_hasta) > $moment() ||
                        $moment(form.fecha_hasta, 'YYYY-MM-DD').format(
                          'YYYY-MM-DD'
                        ) == $moment().format('YYYY-MM-DD')
                      ) {
                        return 'La fecha de finalizacion no puede ser despues o igual a la fecha actual';
                      }
                      if (
                        form.fecha_hasta &&
                        $moment(form.fecha_hasta) < $moment(form.fecha_desde)
                      ) {
                        return 'La fecha de finalizacion no puede ser antes de la fecha inicio';
                      }
                      return true;
                    }
                  ]"
                >
                </v-text-field>
              </v-flex>

           <v-flex :class="tipo_asignacion === '1' ? 'md12' : 'md6'">
  <v-select
    :items="horarios"
    item-value="id"  
    :item-text="
      val =>
        val.descripcion +
        ': ' +
        $moment(val.hora_inicio, 'HH:mm:ss').format('HH:mm') +
        ' - ' +
        $moment(val.hora_fin, 'HH:mm:ss').format('HH:mm')
    "
    :label="
      tipo_asignacion === '1'
        ? 'Seleccione un horario'
        : 'Seleccione primer horario'
    "
    v-model="form.id_horario"
    :rules="$validate(['required'])"
    required
    outline
    clearable
  ></v-select>
</v-flex>
<v-flex md6 v-if="tipo_asignacion === '2'">
  <v-select
    :items="horarios"
    item-value="id"  
    :item-text="
      val =>
        val.descripcion +
        ': ' +
        $moment(val.hora_inicio, 'HH:mm:ss').format('HH:mm') +
        ' - ' +
        $moment(val.hora_fin, 'HH:mm:ss').format('HH:mm')
    "
    label="Seleccione segundo horario"
    v-model="form.id_horario2"
    :rules="$validate(['required'])"
    required
    outline
    clearable
  ></v-select>
</v-flex>



            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      horarios: [],
      datos_horario: {},
      tipo_asignacion: "1",
      user: this.$storage.get("user"),
      l_horarios_historico: []
    };
  },
  watch: {},
  mounted() {
    this.obtenerHorarios();
    this.$bus.$on("openDialogAsignarHorarioHistorico", (item, l_horarios) => {
      this.datos_horario = item;
      this.l_horarios_historico = l_horarios;
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para actualizar las validaciones de las fechas
    actualizaFecha() {
      this.$refs.form.validate();
    },
    // Valida que el nuevo horario historico no choque con otro horario ya registrado
    verificaCoincidenciaHorario(fecha_desde, fecha_hasta, hora_inicio, hora_fin) {
  console.log("=== INICIO VALIDACIÓN HORARIO ===");
  console.log("Nuevo horario:", { fecha_desde, fecha_hasta, hora_inicio, hora_fin });
  
  for (let horarioHistorico of this.l_horarios_historico) {
    console.log("Horario histórico:", horarioHistorico);
    
    // Convertir IDs a números para comparación
    const idHorarioHistorico = Number(horarioHistorico.id_horario);
    
    // Buscar el horario en la lista de horarios disponibles
    const horarioExistente = this.horarios.find(h => Number(h.id) === idHorarioHistorico);
    
    if (!horarioExistente) {
      console.log("No se encontró horario existente para ID:", idHorarioHistorico);
      continue;
    }
    
    console.log("Horario existente encontrado:", horarioExistente);
    
    // VERIFICAR COINCIDENCIA DE FECHAS
    const fechaInicioNueva = this.$moment(fecha_desde);
    const fechaFinNueva = this.$moment(fecha_hasta);
    const fechaInicioExistente = this.$moment(horarioHistorico.fecha_desde);
    const fechaFinExistente = this.$moment(horarioHistorico.fecha_hasta);
    
    console.log("Fechas nueva:", fechaInicioNueva.format('YYYY-MM-DD'), "a", fechaFinNueva.format('YYYY-MM-DD'));
    console.log("Fechas existente:", fechaInicioExistente.format('YYYY-MM-DD'), "a", fechaFinExistente.format('YYYY-MM-DD'));
    
    // Verificar si los rangos de fechas se solapan
    const fechasSeSolapan = 
      (fechaInicioNueva.isSameOrBefore(fechaFinExistente) && 
       fechaFinNueva.isSameOrAfter(fechaInicioExistente));
    
    console.log("¿Fechas se solapan?", fechasSeSolapan);
    
    if (fechasSeSolapan) {
      // VERIFICAR COINCIDENCIA DE HORARIOS
      const horaInicioNueva = this.$moment(hora_inicio, 'HH:mm:ss');
      const horaFinNueva = this.$moment(hora_fin, 'HH:mm:ss');
      const horaInicioExistente = this.$moment(horarioExistente.hora_inicio, 'HH:mm:ss');
      const horaFinExistente = this.$moment(horarioExistente.hora_fin, 'HH:mm:ss');
      
      console.log("Horas nueva:", horaInicioNueva.format('HH:mm'), "a", horaFinNueva.format('HH:mm'));
      console.log("Horas existente:", horaInicioExistente.format('HH:mm'), "a", horaFinExistente.format('HH:mm'));
      
      // Verificar si los rangos horarios se solapan
      const horariosSeSolapan = 
        (horaInicioNueva.isBefore(horaFinExistente) && 
         horaFinNueva.isAfter(horaInicioExistente));
      
      console.log("¿Horarios se solapan?", horariosSeSolapan);
      
      if (horariosSeSolapan) {
        console.log("=== COINCIDENCIA ENCONTRADA ===");
        return true;
      }
    }
  }
  
  console.log("=== SIN COINCIDENCIAS ===");
  return false;
},

// Función auxiliar mejorada para verificar solapamiento entre dos horarios
horariosSeSolapan(horario1, horario2) {
  const horaInicio1 = this.$moment(horario1.hora_inicio, 'HH:mm:ss');
  const horaFin1 = this.$moment(horario1.hora_fin, 'HH:mm:ss');
  const horaInicio2 = this.$moment(horario2.hora_inicio, 'HH:mm:ss');
  const horaFin2 = this.$moment(horario2.hora_fin, 'HH:mm:ss');

  return (
    (horaInicio1.isBefore(horaFin2) && horaFin1.isAfter(horaInicio2))
  );
},

  // Tu función verificaCoincidenciaHorario actualizada
 // Reemplaza completamente tu método verificaCoincidenciaHorario
verificaCoincidenciaHorario(fecha_desde, fecha_hasta, hora_inicio, hora_fin) {
  console.log("🔍 VALIDANDO COINCIDENCIA DE HORARIOS");
  console.log("Nuevo horario - Fecha:", fecha_desde, "a", fecha_hasta, "Hora:", hora_inicio, "a", hora_fin);
  
  // Convertir a momentos para comparación
  const nuevaFechaInicio = this.$moment(fecha_desde);
  const nuevaFechaFin = this.$moment(fecha_hasta);
  const nuevaHoraInicio = this.$moment(hora_inicio, 'HH:mm:ss');
  const nuevaHoraFin = this.$moment(hora_fin, 'HH:mm:ss');
  
  for (let horarioHistorico of this.l_horarios_historico) {
    console.log("📋 Horario histórico:", horarioHistorico);
    
    // Buscar el horario en la lista de horarios disponibles
    const horarioExistente = this.horarios.find(h => Number(h.id) === Number(horarioHistorico.id_horario));
    
    if (!horarioExistente) {
      console.log("❌ No se encontró horario existente");
      continue;
    }
    
    console.log("⏰ Horario existente:", horarioExistente.descripcion, horarioExistente.hora_inicio, "-", horarioExistente.hora_fin);
    
    // Convertir fechas y horas del horario existente
    const existenteFechaInicio = this.$moment(horarioHistorico.fecha_desde);
    const existenteFechaFin = this.$moment(horarioHistorico.fecha_hasta);
    const existenteHoraInicio = this.$moment(horarioExistente.hora_inicio, 'HH:mm:ss');
    const existenteHoraFin = this.$moment(horarioExistente.hora_fin, 'HH:mm:ss');
    
    // VERIFICAR SOLAPAMIENTO DE FECHAS
    const fechasSeSolapan = 
      (nuevaFechaInicio.isSameOrBefore(existenteFechaFin, 'day') && 
       nuevaFechaFin.isSameOrAfter(existenteFechaInicio, 'day'));
    
    console.log("📅 Fechas se solapan?", fechasSeSolapan);
    
    if (fechasSeSolapan) {
      // VERIFICAR SOLAPAMIENTO DE HORAS
      const horariosSeSolapan = 
        (nuevaHoraInicio.isBefore(existenteHoraFin) && 
         nuevaHoraFin.isAfter(existenteHoraInicio));
      
      console.log("⏱️ Horas se solapan?", horariosSeSolapan);
      
      if (horariosSeSolapan) {
        console.log("🚫 COINCIDENCIA ENCONTRADA - No se puede asignar el horario");
        return true;
      }
    }
  }
  
  console.log("✅ SIN COINCIDENCIAS - Horario disponible");
  return false;
},

// Método auxiliar mejorado para verificar solapamiento entre dos horarios del mismo día
horariosSeSolapan(horario1, horario2) {
  const horaInicio1 = this.$moment(horario1.hora_inicio, 'HH:mm:ss');
  const horaFin1 = this.$moment(horario1.hora_fin, 'HH:mm:ss');
  const horaInicio2 = this.$moment(horario2.hora_inicio, 'HH:mm:ss');
  const horaFin2 = this.$moment(horario2.hora_fin, 'HH:mm:ss');

  return (
    horaInicio1.isBefore(horaFin2) && 
    horaFin1.isAfter(horaInicio2)
  );
},
    
    async obtenerHorarios() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							horarios{
								rows{
									id
									descripcion
                  hora_inicio
                  hora_fin
								}
							}
						}
					`
        });
        this.horarios = res.horarios.rows;
        console.log('this.horarios',this.horarios);
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.datos_horario = {};
      this.valid = false;
      this.dialog = false;
      this.$bus.$emit("closeDialogAsignarHorarioHistorico");
    },

    async save1() {
      if (this.$refs.form.validate()) {
        if (
          this.verificaCoincidenciaHorario(
            this.form.fecha_desde,
            this.form.fecha_hasta
          )
        ) {
          this.$message.info(
            "Las fechas ingresadas coinciden con otro horario"
          );
          return;
        }
        try {
          this.loading = true;
          // CREAMOS EL PRIMER HORARIO
          let data = {
            id_persona: this.datos_horario.id,
            id_horario: this.form.id_horario,
            fecha_desde: this.form.fecha_desde,
            fecha_hasta: this.form.fecha_hasta,
            id_estado: 2,
            _user_created: this.user.id
          };
          let res = await this.$service.graphql({
            query: `
              mutation add($horario_persona: NewHorarioPersona!){
                horarioPersonaAdd(horario_persona: $horario_persona){
                  id
                }
              }
            `,
            variables: {
              horario_persona: data
            }
          });
          if (this.tipo_asignacion != 1) {
            data.id_horario = this.form.id_horario2;
            let res = await this.$service.graphql({
              query: `
              mutation add($horario_persona: NewHorarioPersona!){
                horarioPersonaAdd(horario_persona: $horario_persona){
                  id
                }
              }
            `,
              variables: {
                horario_persona: data
              }
            });
          }
          this.$message.success();
          this.close();
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },


    async save() {
  if (this.$refs.form.validate()) {
    try {
      // Validaciones básicas
      if (!this.form.fecha_desde || !this.form.fecha_hasta || !this.form.id_horario) {
        this.$message.error("Complete todos los campos obligatorios");
        return;
      }

      // Convertir IDs a números
      const idHorario1 = Number(this.form.id_horario);
      const idHorario2 = this.form.id_horario2 ? Number(this.form.id_horario2) : null;

      // Obtener el primer horario seleccionado
      const horario1 = this.horarios.find(h => Number(h.id) === idHorario1);
      
      if (!horario1) {
        this.$message.error("Primer horario no encontrado");
        return;
      }

      console.log("🔄 Validando primer horario...");
      
      // Validar primer horario
      if (this.verificaCoincidenciaHorario(
        this.form.fecha_desde,
        this.form.fecha_hasta,
        horario1.hora_inicio,
        horario1.hora_fin
      )) {
        this.$message.error("❌ El primer horario se solapa con un horario existente en el mismo rango de fechas y horas");
        return;
      }

      let horario2 = null;
      
      // Validar segundo horario si es discontinuo
      if (this.tipo_asignacion !== "1" && idHorario2) {
        horario2 = this.horarios.find(h => Number(h.id) === idHorario2);
        
        if (!horario2) {
          this.$message.error("Segundo horario no encontrado");
          return;
        }

        console.log("🔄 Validando segundo horario...");
        
        // Validar segundo horario
        if (this.verificaCoincidenciaHorario(
          this.form.fecha_desde,
          this.form.fecha_hasta,
          horario2.hora_inicio,
          horario2.hora_fin
        )) {
          this.$message.error("❌ El segundo horario se solapa con un horario existente en el mismo rango de fechas y horas");
          return;
        }

        // Validar que los dos horarios no se solapen entre sí
        if (this.horariosSeSolapan(horario1, horario2)) {
          this.$message.error("❌ Los dos horarios seleccionados se solapan entre sí");
          return;
        }
      }

      this.loading = true;

      // CREAR PRIMER HORARIO
      let dataHorario1 = {
        id_persona: this.datos_horario.id,
        id_horario: idHorario1,
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta,
        id_estado: 2,
        _user_created: this.user.id
      };

      console.log("💾 Guardando primer horario...", dataHorario1);
      
      await this.$service.graphql({
        query: `
          mutation add($horario_persona: NewHorarioPersona!){
            horarioPersonaAdd(horario_persona: $horario_persona){
              id
            }
          }
        `,
        variables: {
          horario_persona: dataHorario1
        }
      });

      // CREAR SEGUNDO HORARIO si es discontinuo
      if (this.tipo_asignacion !== "1" && horario2) {
        let dataHorario2 = {
          id_persona: this.datos_horario.id,
          id_horario: idHorario2,
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_hasta,
          id_estado: 2,
          _user_created: this.user.id
        };

        console.log("💾 Guardando segundo horario...", dataHorario2);
        
        await this.$service.graphql({
          query: `
            mutation add($horario_persona: NewHorarioPersona!){
              horarioPersonaAdd(horario_persona: $horario_persona){
                id
              }
            }
          `,
          variables: {
            horario_persona: dataHorario2
          }
        });
      }

      this.$message.success("✅ Horario asignado correctamente");
      this.close();
      
    } catch (error) {
      console.error("💥 Error al asignar horario:", error);
      this.$message.error("❌ Error al asignar el horario: " + (error.message || "Error desconocido"));
    } finally {
      this.loading = false;
    }
  }
}




  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/AsignarHorarioHistorico.vue